module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30.328 2.344l-6.708-.156c-.56-.012-1.09.704-.722 1.274l2.326 2.378-5.278 5.092-7.694-6.406c-.412-.418-.956-.512-1.492-.438-.482-.048-.968.058-1.336.426l-8.078 6.404a1.672 1.672 0 1 0 2.366 2.364l6.886-5.458 9.348 7.786 1.496-1.514c.006-.008.018-.006.022-.012l6.082-5.868 1.962 2.006c.366.568 1.14.326 1.322-.238l.272-6.654c.182-.564-.216-.97-.774-.986z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/nutrients-highlight.js
// module id = 1311
// module chunks = 14